// Returns the date if it is between business hours.

import dayjs, { type Dayjs } from 'dayjs'
import z from 'zod/v4'

// Otherwise returns a new date at the start of the next business day.
function businessHours(date: Date | Dayjs): Date {
  return dayjs(date).toDate()

  /* const time = dayjs(date)
  const startOfDay = time.startOf('day').add(7, 'hour')
  const endOfDay = time.startOf('day').add(22, 'hour')

  if (time.isAfter(startOfDay) && time.isBefore(endOfDay)) {
    return dayjs(date).toDate()
  }

  // If after business hours today, return 8 AM tomorrow

  if (time.isAfter(endOfDay)) {
    return time.add(1, 'day').startOf('day').add(8, 'hour').toDate()
  }

  // If before business hours today, return 7 AM today
  return startOfDay.toDate() */
}

export const sendScheduleKeys = z.union([
  z.literal('now'),
  z.literal('one_hour'),
  z.literal('next_morning'),
])

export type SendScheduleKey = z.infer<typeof sendScheduleKeys>

export const sendScheduleOptions: {
  key: SendScheduleKey
  value: (refDate: Date) => Date
}[] = [
  {
    key: 'now',
    value: (refDate: Date) => businessHours(dayjs(refDate)),
  },
  {
    key: 'one_hour',
    value: (refDate: Date) => businessHours(dayjs(refDate).endOf('hour').add(1, 'hour')),
  },
  {
    key: 'next_morning',
    value: (refDate: Date) =>
      businessHours(dayjs(refDate).add(1, 'day').startOf('day').add(9, 'hour')),
  },
]

export function checkSendFeedbackRequestTiming(
  sendAt: Date | Dayjs,
  previousSendAt?: Date | Dayjs
) {
  const minimumTimeout = dayjs(sendAt).subtract(1, 'day')

  if (previousSendAt && dayjs(previousSendAt).isAfter(minimumTimeout)) {
    return false
  }

  return true
}

export function getNextSendAt(sendAt: Date | Dayjs, previousSendAt?: Date | Dayjs) {
  if (!checkSendFeedbackRequestTiming(sendAt, previousSendAt)) {
    return dayjs(previousSendAt).add(1, 'day')
  }

  return sendAt
}

export function getScheduleKeyFromDate(date: Date | Dayjs) {
  return sendScheduleOptions.reduce<SendScheduleKey>((closest, option) => {
    const refDate = dayjs(date).toDate()
    const optionTime = option.value(refDate)

    const closestTime = sendScheduleOptions.find((opt) => opt.key === closest)?.value(refDate)

    if (!closestTime) return option.key

    const optionDiff = Math.abs(refDate.getTime() - optionTime.getTime())
    const closestDiff = Math.abs(refDate.getTime() - closestTime.getTime())

    return optionDiff < closestDiff ? option.key : closest
  }, 'now')
}

export function getDateFromScheduleKey(scheduleKey: SendScheduleKey, referenceDate: Date | Dayjs) {
  return sendScheduleOptions
    .find((option) => option.key === scheduleKey)
    ?.value(dayjs(referenceDate).toDate())
}
